export default __webpack_public_path__ + "static/media/ICONairALL.4fb1ed1f.svg";